// @flow

import React from 'react';
import styled from 'styled-components';
import ListContainer from '../../list';
import type { Theme } from '../../../types';
import svgToEnglish from '../svg-to-english';

const Header = styled<any, Theme>('div')`
  color: ${props => props.theme.faq.categoryInOverview.title.color};
  display: inline-flex;
  line-height: 2.25em;
  margin-bottom: 1em;
`;

const Icon = styled<any, Theme>('i')`
  margin-right: .5rem;
  flex-shrink: 1;
  font-size: 2.5rem;
  color: ${props => props.theme.faq.categoryInOverview.iconColor};
`;

const Title = styled<any, Theme>('h1')`
  color: ${props => props.theme.faq.categoryInOverview.title.color};
  font-size: ${props => props.theme.faq.categoryInOverview.title.fontSize};
  font-weight: ${props => props.theme.faq.categoryInOverview.title.fontWeight};
`;

type Props = {|
  icon?: string, // eslint-disable-line react/require-default-props
  subcategories: Array<{
    title: string,
    url: string,
  }>,
  title: string,
|};

const CategoryInOverview = ({
  icon = '',
  subcategories,
  title,
}: Props) => (
  <section>
    <Header>
      {icon && (<Icon className={`icon-${svgToEnglish(icon)}`} />)}
      <Title>{title}</Title>
    </Header>
    <ListContainer
      compact
      listStyle="bullets"
      items={subcategories.map(subcategory => ({
        usp: subcategory.title,
        url: subcategory.url,
      }))}
    />
  </section>
);

export default CategoryInOverview;
